import Header from '@/components/layout/Header'

const Dashboard = () => import(/* webpackChunkName: "dashboard-group" */ '@/views/dashboard/Dashboard')
const NoAuth = () => import(/* webpackChunkName: "dashboard-group" */ '@/components/layout/NoAuth')
const ListAuths = () => import(/* webpackChunkName: "auth-group" */ '@/views/auth/ListAuths')
const ListRoles = () => import(/* webpackChunkName: "auth-group" */ '@/views/auth/ListRoles')
const ViewRole = () => import(/* webpackChunkName: "auth-group" */ '@/views/auth/ViewRole')
const Message = () => import(/* webpackChunkName: "message-group" */ '@/views/message/Message')

export default [
  {
    path: '/dashboard',
    name: 'dashboard',
    components: {
      main: Dashboard
    },
    meta: {
      title: '工作台'
    }
  },
  {
    path: '/auth',
    name: 'list-auths',
    components: {
      header: Header,
      main: ListAuths
    },
    meta: {
      header: Header,
      title: '权限体系'
    }
  },
  {
    path: '/roles',
    name: 'list-roles',
    components: {
      header: Header,
      main: ListRoles
    },
    meta: {
      header: Header,
      title: '系统角色'
    }
  },
  {
    path: '/role',
    name: 'view-role',
    components: {
      header: Header,
      main: ViewRole
    },
    meta: {
      title: '角色权限详情'
    }
  },
  {
    path: '/message',
    name: 'message',
    components: {
      header: Header,
      main: Message
    },
    meta: {
      title: '消息'
    }
  },
  {
    path: '/no-auth',
    name: 'no-auth',
    components: {
      main: NoAuth
    },
    meta: {
      title: '没有权限'
    }
  }
]
